// extracted by mini-css-extract-plugin
export default {"web":"Web_web__2nnNv","webOption":"Web_webOption__kjGGU","optionIcon":"Web_optionIcon__BZkwS"};